// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .open, .closed{
    width: -moz-available !important;          /* WebKit-based browsers will ignore this. */
    width: -webkit-fill-available !important;  /* Mozilla-based browsers will ignore this. */
    width: fill-available !important;
  }
  .containerPanel{
    background: #fff;
    padding: 16px;
    min-height: 500px;

  }
  .formContainer {
    min-width: 258px;
    min-height: 642px;
    padding: 16px;
    background: #fff;
}

.containerPanel .css-mhc70k-MuiGrid-root{
    padding: 0px !important;
    margin: 0px !important;
    width: 100% !important;
    height: 100% !important;

}
.css-mhc70k-MuiGrid-root > .MuiGrid-item {
  padding-left: 0px !important;
}
.formContainerInner {
    height: 100%;
    padding: 16px;
    border-radius: 4px;
    border: 1px solid #D6DCEB;
    margin-bottom: 20px;
}
.formTitle {
    font-size: 10px;
    font-weight: 800;
    line-height: 14px;
    margin-top: -30px;
    color: #666666 !important;
    position: relative;
    background-color: white;
    padding: 6px;
    padding-left: 0;
    width: fit-content;
}

.estado-en-proceso {
  position: relative;
  color: #FFD700;
}

.estado-en-proceso::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  background-color: #FFD700;
  border-radius: 50%;
}

.completado {
  color: #008000;
  position: relative;
}

.completado::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  background-color: #008000;
  border-radius: 50%;
}


.fallido {
  color: #FF0000;
  position: relative;
}

.fallido::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  background-color: #FF0000;
  border-radius: 50%;
}

.procesando-pagos {
  color: #FFA500;
  position: relative;
}

.procesando-pagos::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  background-color: #FFA500;
  border-radius: 50%;
}

.generando-archivo {
  color: #0000FF;
  position: relative;
}

.generando-archivo::before {
  content: '';
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 10px;
  height: 10px;
  background-color: #0000FF;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./src/adminCore/cobranza/assets/style.css"],"names":[],"mappings":"EAAE;IACE,gCAAgC,WAAW,4CAA4C;IACvF,wCAAwC,GAAG,6CAA6C;IACxF,gCAAgC;EAClC;EACA;IACE,gBAAgB;IAChB,aAAa;IACb,iBAAiB;;EAEnB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;;AAE3B;AACA;EACE,4BAA4B;AAC9B;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":["  .open, .closed{\r\n    width: -moz-available !important;          /* WebKit-based browsers will ignore this. */\r\n    width: -webkit-fill-available !important;  /* Mozilla-based browsers will ignore this. */\r\n    width: fill-available !important;\r\n  }\r\n  .containerPanel{\r\n    background: #fff;\r\n    padding: 16px;\r\n    min-height: 500px;\r\n\r\n  }\r\n  .formContainer {\r\n    min-width: 258px;\r\n    min-height: 642px;\r\n    padding: 16px;\r\n    background: #fff;\r\n}\r\n\r\n.containerPanel .css-mhc70k-MuiGrid-root{\r\n    padding: 0px !important;\r\n    margin: 0px !important;\r\n    width: 100% !important;\r\n    height: 100% !important;\r\n\r\n}\r\n.css-mhc70k-MuiGrid-root > .MuiGrid-item {\r\n  padding-left: 0px !important;\r\n}\r\n.formContainerInner {\r\n    height: 100%;\r\n    padding: 16px;\r\n    border-radius: 4px;\r\n    border: 1px solid #D6DCEB;\r\n    margin-bottom: 20px;\r\n}\r\n.formTitle {\r\n    font-size: 10px;\r\n    font-weight: 800;\r\n    line-height: 14px;\r\n    margin-top: -30px;\r\n    color: #666666 !important;\r\n    position: relative;\r\n    background-color: white;\r\n    padding: 6px;\r\n    padding-left: 0;\r\n    width: fit-content;\r\n}\r\n\r\n.estado-en-proceso {\r\n  position: relative;\r\n  color: #FFD700;\r\n}\r\n\r\n.estado-en-proceso::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -20px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: #FFD700;\r\n  border-radius: 50%;\r\n}\r\n\r\n.completado {\r\n  color: #008000;\r\n  position: relative;\r\n}\r\n\r\n.completado::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -20px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: #008000;\r\n  border-radius: 50%;\r\n}\r\n\r\n\r\n.fallido {\r\n  color: #FF0000;\r\n  position: relative;\r\n}\r\n\r\n.fallido::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -20px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: #FF0000;\r\n  border-radius: 50%;\r\n}\r\n\r\n.procesando-pagos {\r\n  color: #FFA500;\r\n  position: relative;\r\n}\r\n\r\n.procesando-pagos::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -20px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: #FFA500;\r\n  border-radius: 50%;\r\n}\r\n\r\n.generando-archivo {\r\n  color: #0000FF;\r\n  position: relative;\r\n}\r\n\r\n.generando-archivo::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: -20px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 10px;\r\n  height: 10px;\r\n  background-color: #0000FF;\r\n  border-radius: 50%;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
